import MobileTableBody from "./MobileTableBody";
import MobileTableHeader from "./MobileTableHeader";

const MobileTable = ({
  title,
  description,
  data,
  columns,
  actions,
  noDataMessage = "No hay registros disponibles."
}) => {
  return (
    <section className="w-full">
      {title && (
        <MobileTableHeader
          title={title}
          description={description}
        />
      )}

      <MobileTableBody
        data={data}
        columns={columns}
        actions={actions}
        noDataMessage={noDataMessage}
      />
    </section>
  );
};

export default MobileTable;
